/**
 * Toast notification wrapper — the ONE way this app shows a transient message.
 *
 * Call these rather than @mantine/notifications directly: the durations and colours are decided
 * once here, so a success toast looks and behaves the same everywhere. Errors deliberately do not
 * auto-dismiss — a message the user never saw is the same as no message.
 */
import { notifications } from '@mantine/notifications'

const Notify = {
  success: (message) => {
    notifications.show({ message, color: 'green', autoClose: 4000 })
  },
  error: (message) => {
    notifications.show({ message, color: 'red', autoClose: false, withCloseButton: true })
  },
  info: (message) => {
    notifications.show({ message, color: 'blue', autoClose: 4000 })
  },
  warning: (message) => {
    notifications.show({ message, color: 'yellow', autoClose: 4000 })
  },
}

export default Notify
